import type { SVGProps } from 'react';
import * as React from 'react';
import { forwardRef, Ref } from 'react';

const SvgCalculator = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.25 9.375h7.5a.625.625 0 0 0 .625-.625V5a.625.625 0 0 0-.625-.625h-7.5A.625.625 0 0 0 5.625 5v3.75a.625.625 0 0 0 .625.625m.625-3.75h6.25v2.5h-6.25zm8.75-3.75H4.375a1.25 1.25 0 0 0-1.25 1.25v13.75a1.25 1.25 0 0 0 1.25 1.25h11.25a1.25 1.25 0 0 0 1.25-1.25V3.125a1.25 1.25 0 0 0-1.25-1.25m0 15H4.375V3.125h11.25zm-7.812-5.312a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0m3.125 0a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0m3.124 0a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0m-6.25 3.124a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.875 0m3.125 0a.937.937 0 1 1-1.874 0 .937.937 0 0 1 1.874 0m3.126 0a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.874 0"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCalculator);
export default ForwardRef;
